module.exports = __webpack_public_path__ + "static/media/sec-3-dashed-backg.fc92eac6.png";